export default __webpack_public_path__ + "static/media/NutritionChartOn.5ada9cef.svg";